<template>
    <div class="wrap">
        <el-row :gutter="20" class="main_block">
            <div class="mianContent">
                <div class="tagView">
                    <div class="title_aside"></div>
                    <el-breadcrumb separator-class="el-icon-arrow-right" style="width:60px; float:left;line-height:normal">
                        <el-breadcrumb-item>{{
                            $route.meta.title
                        }}</el-breadcrumb-item>
                    </el-breadcrumb>
                    <p class="ts">账户合并升级，仅支持2020.1.1至今的订单在线申请，如申请2020.1.1之前的发票，联系客服进行线下申请</p>
                </div>
                <div class="tableBox">
                    <el-tabs v-model="activeName"  @tab-click="handleClick">
                        <el-tab-pane label="可开票订单" name="first">
                            <div class="searchBar">
                                <el-form
                                    :model="searchParam1"
                                    status-icon
                                    ref="searchData"
                                    label-position="left"
                                    label-width="90px"
                                    :inline="true"
                                >
                                    <el-form-item label="">
                                        <el-date-picker
                                            v-model="dataVal1"
                                            @change="datetime"
                                            type="datetimerange"
                                            align="right"
                                            start-placeholder="支付完成开始时间"
                                            end-placeholder="支付完成结束时间"
                                            format="yyyy-MM-dd"
                                            value-format="timestamp"
                                            :default-time="['00:00:00', '23:59:59']"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <el-input
                                            type="text"
                                            v-model="searchParam1.orderId"
                                            autocomplete="off"
                                            placeholder="请输入订单号"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <el-button
                                            type="primary"
                                            @click="selectTable('first')"
                                            >查询</el-button
                                        >
                                        <el-button
                                            type="info"
                                            @click="
                                                (dataVal1='',searchParam1 = {page: 1,size: 10,invoiceStatus:['1']},pageSizeNum1=10),
                                                    selectTable('first')
                                            "
                                            >重置</el-button
                                        >
                                        <el-button
                                            :disabled="selection.length==0"
                                            type="primary"
                                            @click="apply"
                                            >申请开票</el-button
                                        >
                                    </el-form-item>
                                </el-form>
                            </div>
                            <ExTable
                                :table-list="tableData1"
                                :header="header1"
                                :isIndex="false"
                                height="300"
                                ref="multipleTable"
                                tableName="table1"
                                :select="true"
                                :total="total1"
                                :tableId="1"
                                :activeIndex="searchParam1.page"
                                :pageSizeNum="pageSizeNum1"
                                @clickPage="clickPage"
                                @clickSize="clickSize"
                                @selection-change="handleSelectionChange"
                            />
                        </el-tab-pane>
                        <el-tab-pane label="不可开票订单" name="second">
                            <div class="searchBar">
                                <el-form
                                    :model="searchParam2"
                                    status-icon
                                    ref="searchData"
                                    label-position="left"
                                    label-width="90px"
                                    :inline="true"
                                >
                                    <el-form-item label="">
                                        <el-date-picker
                                            v-model="dataVal2"
                                            @change="datetime"
                                            type="datetimerange"
                                            align="right"
                                            start-placeholder="支付完成开始时间"
                                            end-placeholder="支付完成结束时间"
                                            format="yyyy-MM-dd"
                                            value-format="timestamp"
                                            :default-time="['00:00:00', '23:59:59']"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <el-input
                                            type="text"
                                            v-model="searchParam2.orderId"
                                            autocomplete="off"
                                            placeholder="请输入订单号"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <el-button
                                            type="primary"
                                            @click="selectTable('second')"
                                            >查询</el-button
                                        >
                                        <el-button
                                            type="info"
                                            @click="
                                                (dataVal2='',searchParam2 = {page: 1,size: 10,invoiceStatus:['0','2']},pageSizeNum2=10),
                                                    selectTable('second')
                                            "
                                            >重置</el-button
                                        >
                                    </el-form-item>
                                </el-form>
                            </div>
                            <ExTable
                                :table-list="tableData2"
                                :header="header2"
                                :isIndex="false"
                                height="300"
                                :total="total2"
                                :tableId="2"
                                :activeIndex="searchParam2.page"
                                :pageSizeNum="pageSizeNum2"
                                @clickPage="clickPage"
                                @clickSize="clickSize"
                            />
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </el-row>
    </div>
</template>

<script>
import qs from 'qs'
import ExTable from "@com/ExTable";
import {orderData} from "@http/order/index";
import {addOrder} from "@http/invoice/index";
import { formatDate, filterParams, sourceType } from "@/utils/filter";
export default {
    name: "apply",
    data() {
        return {
            activeName: "first",
            dataVal1: "",
            dataVal2: "",
            pageSizeNum1:10,
            pageSizeNum2:10,
            //可开票
            searchParam1: {
                page: 1,
                size: 10,
                invoiceStatus: ['1'],
                orderId: "",
                startPaymentAt: "",
                endPaymentAt: "",
            },
            tableData1: [],
            header1: [
                { prop: "id", label: "订单号" ,minWidth:100},
                {
                    width:100,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount+'个';
                    },
                },
                {
                    minWidth:100,
                    prop: "suiteName",
                    label: "服务包名称",
                },
                {
                    minWidth:80,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
                {
                    width:80,
                    prop: "sourceTypeName",
                    label: "订单来源",
                },
                {
                    minWidth:100,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                        return row.payAmount+'元'
                    },
                },
                {
                    minWidth:100,
                    prop: "invoiceAmount",
                    label: "可开票金额",
                    formatter: (row) => {
                        return row.invoiceAmount+'元'
                        // if(row.status==127){
                        //     return (row.invoiceAmount-row.refundAmount)+'元'
                        // }
                        // if(row.status==3){
                        //     if(row.invoiceAmount==0){
                        //         return (row.payAmount-row.refundAmount)+'元'
                        //     }else{
                        //         return (row.invoiceAmount < (row.payAmount-row.refundAmount) ? row.invoiceAmount :  row.payAmount-row.refundAmount)+'元'
                        //     }
                        // }else{
                        //     if(row.invoiceAmount==0){
                        //         return row.payAmount+'元'
                        //     }else{
                        //         return row.invoiceAmount+'元'
                        //     }
                        // }
                    },
                },
                {
                    minWidth:100,
                    prop: "invoiceStatus",
                    label: "状态",
                    render: (h, data) => {
                        switch (data.row.invoiceStatus) {
                            case 0:
                                return (<span>不可开票</span>);
                                break;
                            case 1:
                                return (<span style="color:#D9A915">未开票</span>);
                                break;
                            case 2:
                                return (<span>已开票</span>);
                                break;
                        }
                    },
                },
                {
                    width:80,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        switch (row.payType) {
                            case 0:
                                return "未支付";
                                break;
                            case 1:
                                return "支付宝";
                                break;
                            case 2:
                                return "微信";
                                break;
                            case 3:
                                return "银联";
                                break;
                            case 4:
                                return "赠送";
                                break;
                            case 5:
                                return "兑换码";
                                break;
                            case 8:
                                return "转入";
                                break;
                            case 9:
                                return "--";
                                break;
                            case 127:
                                return "--";
                                break;
                        }
                    },
                    
                },
                {
                    prop: "paymentAt",
                    minWidth:110,
                    label: "支付完成时间",
                    formatter: (row) => {
                        return formatDate(row.paymentAt);
                    },
                },
            ],
            total1: 10,
            //不可开票
            searchParam2: {
                page: 1,
                size: 10,
                invoiceStatus:['0','2'],
                orderId: "",
                startPaymentAt: "",
                endPaymentAt: "",
            },
            tableData2: [],
            header2: [
                { prop: "id", label: "订单号",minWidth:100},
                // {
                //     prop: "createdAt",
                //     width:180,
                //     label: "创建时间",
                //     formatter: (row) => {
                //         return formatDate(row.createdAt);
                //     },
                // },
                {
                    width:100,
                    prop: "tsCount",
                    label: "时间戳总数",
                    formatter: (row) => {
                        return row.tsCount+'个';
                    },
                },
                {
                    minWidth:80,
                    prop: "suiteValidityPeriod",
                    label: "有效期",
                    formatter: (row) => {
                        if(row.suiteValidityPeriod==0){
                            return '永久有效'
                        }else{
                            return row.suiteValidityPeriod+'天'
                        }
                    },
                },
                {
                    width:80,
                    prop: "sourceTypeName",
                    label: "订单来源",
                },
                {
                    minWidth:100,
                    prop: "payAmount",
                    label: "实付金额",
                    formatter: (row) => {
                        return row.payAmount+'元'
                    },
                },
                {
                    minWidth:100,
                    prop: "invoiceStatus",
                    label: "状态",
                    render: (h, data) => {
                        switch (data.row.invoiceStatus) {
                            case 0:
                                return (<span style="color:#999999">不可开票</span>);
                                break;
                            case 1:
                                return (<span>未开票</span>);
                                break;
                            case 2:
                                return (<span style="color:#4F9E48">已开票</span>);
                                break;
                        }
                    },
                },
                {
                    width:80,
                    prop: "payType",
                    label: "支付方式",
                    formatter: (row) => {
                        switch (row.payType) {
                            case 0:
                                return "未支付";
                                break;
                            case 1:
                                return "支付宝";
                                break;
                            case 2:
                                return "微信";
                                break;
                            case 3:
                                return "银联";
                                break;
                            case 4:
                                return "赠送";
                                break;
                            case 5:
                                return "兑换码";
                                break;
                            case 6:
                                return "预充值";
                                break;
                            case 8:
                                return "转入";
                                break;
                            case 9:
                                return "--";
                                break;
                            case 127:
                                return "--";
                                break;
                        }
                    },
                },
                {
                    prop: "paymentAt",
                    minWidth:110,
                    label: "支付完成时间",
                    formatter: (row) => {
                        return formatDate(row.paymentAt);
                    },
                },
                {
                    prop: "invoiceApplyAt",
                    minWidth:110,
                    label: "申请开票时间",
                    formatter: (row) => {
                        if(row.invoiceApplyAt){
                            return formatDate(row.invoiceApplyAt);
                        }else{
                            return "--"
                        }
                        
                    },
                },
                {
                    label: "操作",
                    width:80,
                    render: (h, data) => {
                        const gohistory=()=>{
                            this.$router.push({
                                path:"/invoice/history",
                                query:{
                                    orderNo:data.row.id
                                }
                            })
                        }
                        if(!data.row.invoiceApplyAt){
                            return (
                                <div>--</div>
                            )
                        }else{
                            return (
                                <div>
                                    <el-tooltip class="item" effect="dark" content="开票历史" placement="top">
                                        <i class="el-icon-ali-dingdanshijian icon-btn" onClick={gohistory}></i>
                                    </el-tooltip>
                                </div>
                            )
                        }
                        
                        // if(data.row.invoiceStatus==2){
                        //     return (
                        //         <div>
                        //             <el-tooltip class="item" effect="dark" content="开票历史" placement="top">
                        //                 <i class="el-icon-ali-dingdanshijian icon-btn" onClick={gohistory}></i>
                        //             </el-tooltip>
                        //         </div>
                        //     )
                        // }else{
                        //     return (
                        //         <div>--</div>
                        //     )
                        // }
                        
                    }
                },
            ],
            total2: 10,
            selection:[],//当前页选择的行
        };
    },
    components: {
        ExTable,
    },
    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    async created() {
        this.businessCode='3';
        let res = await this.getTableData(filterParams(this.searchParam1));
        this.tableData1 = res.data;
        this.total1 = res.total;
        this.toggle();
    },
    mounted() {
        zhuge.track('用户中心_进入发票管理', {'渠道': this.channelCodeValue,'用户行为':'开发票'})
    },
    methods: {
        toggle(){
            this.$nextTick(() => {
                this.selection.forEach((row, index) => {
                    this.tableData1.forEach((_row, _index) => {
                        if (row.id === _row.id) {
                            this.$refs.multipleTable.$refs.table1.toggleRowSelection(_row, true);
                        }
                    })
                })
            })
        },
        async getTableData(data) {
            let res = await orderData(data);
            return res;
        },
        async selectTable(name) {
            let res;
            if (name == "first") {
                this.searchParam1.page = 1;
                res = await this.getTableData(filterParams(this.searchParam1));
                this.tableData1 = res.data;
                this.total1 = res.total;
                this.toggle();
            } else if (name == "second") {
                this.searchParam2.page = 1;
                res = await this.getTableData(filterParams(this.searchParam2));
                this.tableData2 = res.data;
                this.total2 = res.total;
            }
            
        },
        async handleClick(tab) {
            let res;
            if (tab.name == "first") {
                    res = await this.getTableData(
                        filterParams(this.searchParam1)
                    );
                    this.tableData1 = res.data;
                    this.total1 = res.total;
                    this.toggle();
            } else if (tab.name == "second") {
                    res = await this.getTableData(filterParams(this.searchParam2));
                    this.tableData2 = res.data;
                    this.total2 = res.total;
            }
        },
        async clickPage(page, num) {
            let res;
            if (num == 1) {
                this.searchParam1.page = page;
                res = await this.getTableData(filterParams(this.searchParam1));
                this.tableData1 = res.data;
                this.total1 = res.total;
                this.toggle();
            } else if (num == 2) {
                this.searchParam2.page = page;
                res = await this.getTableData(filterParams(this.searchParam2));
                this.tableData2 = res.data;
                this.total2 = res.total;
            }
        },
        async clickSize(size, num) {
            let res;
            if (num == 1) {
                this.searchParam1.page = 1;
                this.searchParam1.size = size;
                this.pageSizeNum1=size;
                res = await this.getTableData(filterParams(this.searchParam1));
                this.tableData1 = res.data;
                this.total1 = res.total;
                this.toggle();
            } else if (num == 2) {
                this.searchParam2.page = 1;
                this.searchParam2.size = size;
                this.pageSizeNum2=size;
                res = await this.getTableData(filterParams(this.searchParam2));
                this.tableData2 = res.data;
                this.total2 = res.total;
            }
        },
        //选择
        handleSelectionChange(val){
            this.selection=val;
            console.log(this.selection)
        },
        getOrderList(){
            let that=this;
            let orderList=[];
            let invoiceAmount;
            this.selection.map((value)=>{
                invoiceAmount= value.invoiceAmount
                // if(value.status==3){
                //     if(value.invoiceAmount==0){
                //         invoiceAmount= (value.payAmount-value.refundAmount)
                //     }else{
                //         //invoiceAmount= (value.invoiceAmount-value.refundAmount)
                //         invoiceAmount= (value.invoiceAmount < (value.payAmount-value.refundAmount) ? value.invoiceAmount :  value.payAmount-value.refundAmount)
                //     }
                // }else if(value.status==127){
                //     invoiceAmount=value.invoiceAmount-value.refundAmount
                // }else{
                //     if(value.invoiceAmount==0){
                //         invoiceAmount= value.payAmount
                //     }else{
                //         invoiceAmount= value.invoiceAmount
                //     }
                // }
                orderList.push(
                    { 
                        'orderId': value.id,
                        'orderAmount': invoiceAmount,
                        'chargeWay':that.payChange(value.payType),
                        'sourceType':975260,//value.sourceType,
                        'orderType':0,
                    }
                )
            })
            let orderObj={orderList}
            sessionStorage.setItem("orderObj", JSON.stringify(orderObj));
        },
        // 确定
        async apply() {
            if(this.selection=={}){
                this.$msg('请选择要申请发票的订单');
                return false;
            }
            this.getOrderList();
            this.$router.push({
                path:'/invoice/personIn'
            })
        },
        payChange(payType){
            switch (payType) {
                case 1:
                    return 113;
                    break;
                case 2:
                    return 115;
                    break;
                case 3:
                    return 108;
                    break;
                case 4:
                    return 109;
                    break;
            }
        },
        datetime(e) {
            if (this.activeName == "first") {
                if (e) {
                    this.searchParam1.startCreatedAt = e[0];
                    this.searchParam1.endCreatedAt = e[1];
                } else {
                    this.searchParam1.startCreatedAt = "";
                    this.searchParam1.endCreatedAt = "";
                }
            } else if (this.activeName == "second") {
                if (e) {
                    this.searchParam2.startCreatedAt = e[0];
                    this.searchParam2.endCreatedAt = e[1];
                } else {
                    this.searchParam1.startCreatedAt = "";
                    this.searchParam1.endCreatedAt = "";
                }
            }
        },
        
    },
};
</script>

<style scoped lang="less">
.ts{
    float:left;
    line-height:1; 
    color:#ff6600; 
    font-size:12px;
    margin-left: 20px;
}
.tagView{
    display: flex;
    align-items: center;
}
</style>
